/* unplugin-vue-components disabled */import script from "./SearchHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SearchHeader.vue?vue&type=style&index=0&id=2e84386a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e84386a"]])

export default __exports__